export const Headshots = [
    {
        image: (
            <img src={require("../assets/headshots/CaitlinKlotz-Headshot1.jpg")} alt="Caitlin Klotz - Headshot 1" />
        )
    },
    {
        image: (
            <img src={require("../assets/headshots/CaitlinKlotz-Headshot2.jpg")} alt="Caitlin Klotz - Headshot 2" />
        )
    },
    {
        image: (
            <img src={require("../assets/headshots/CaitlinKlotz-Headshot3.jpg")} alt="Caitlin Klotz - Headshot 3" />
        )
    },
    {
        image: (
            <img src={require("../assets/headshots/CaitlinKlotz-Headshot4.jpg")} alt="Caitlin Klotz - Headshot 4" />
        )
    }
];